import { Box, Typography } from "@mui/material";

const CustomOverviewCard = ({ onClick, title, icon }) => {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.palette.mode === "dark" ? "#1e1e1e" : "#fff",
        padding: "2em 1.5em",
        width: "100%",
        minWidth: "18.2em",
        borderRadius: "6px",
        cursor: "pointer",
      })}
      onClick={onClick}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Box
          sx={(theme) => ({
            padding: ".5em .7em",
            backgroundColor: theme.palette.mode === "dark" ? "#2a2a2a" : "#F4F6FAB2",
            borderRadius: "10px",
            marginBottom: ".5em",
            width: "3em",
          })}
        >
          <img src={icon} alt="" style={{ width: "100%" }} />
        </Box>
        <Typography
          variant="body2"
          sx={{ fontSize: { xs: ".9rem", md: "1rem" }, fontWeight: 500 }}
        >
          {title}
        </Typography>
      </Box>
    </Box>
  );
};

export default CustomOverviewCard;
